export default "__VITE_ASSET__7f4kX5jC__"